<template>
	<div class="ReSearchObjSmall">
		<!--pre>{{objData}}</pre-->
		<card class="objectCard" @click="OpenComplex(objData.PK)">
			<div class="objectContent">
				<div class="leftPart">
					<div class="objectPhoto">
						<!--img src="/img/modules/l_62252220433d741e4b44abe1e65fb24a.jpg" alt="" @click="OpenComplex(objData.gk_name_tr)"-->
						<!-- <img v-if="objData.gk_avatar !=''" :src="`/DATA/complex_files/NewComplexFiles/${objData.gk_avatar}`" alt="" @click="OpenComplex(objData.gk_name_tr)">  -->
						<img v-if="objData.gk_avatar !=''" :src="`/DATA/complex_files/NewComplexFiles/${objData.gk_avatar}`" alt="" @click="OpenComplex(objData.PK)"> 
						<img v-else src="/img/flatsDefault.svg" alt="" @click="OpenComplex(objData.PK)"> 
						<div class="col objectBadges mt-2 px-0"><span class="badge badge-primary ml-1">Новостройки</span><!--span class="badge badge-info ml-1">Уступка застройщика</span><span class="badge badge-warning ml-1">Апартаменты</spanбейджи ждут возвразщения Артема--></div>

					</div>

				</div>
				<div class="rightPart">
					<div class="row objectHeader">
						<!--div class="col-lg-4 col-md-4 col-sm-12 pr-0"><h4>ЖК &laquo;{{objData.gk_name}}&raquo;</h4></div-->
						<div class="col-lg-4 col-md-4 col-sm-12 pr-0"><h4 class="gkTaskLink" @click="OpenComplex(objData.PK)">ЖК &laquo;{{objData.gk_name}}&raquo;</h4></div>
						<div class="col-lg-4 col-md-4 col-sm-12 flats"><p>Квартир: <span class="ml-2">{{objData.countflat_onsale}}</span></p></div>
					</div>
					<div class="row objectInfo">
						<div class="col-sm-12 col-md-4 objectLocation">
							<div class="metro">
								<div class="row flex-nowrap ml-0 mr-2 align-items-top">
									<i class="tim-ic ic-metro text-primary mr-1"></i>
									<p>{{$GVO.str_replace(',', ', ',objData.metro_name)}}</p> 
								</div> 
								<div class="row ml-0 mr-2 align-items-center">
									<i class="metroIc tim-icons icon-user-run text-primary"></i> 
									<p>{{objData.metro_distance}} мин.</p>									
								</div> 
								<div v-if="objData.metro_distance_transport !='0'" class="row mx-0 align-items-center">
									<i class="metroIc tim-icons icon-bus-front-12 text-primary"></i> 
									<p >{{objData.metro_distance_transport}} мин.</p>									
								</div> 								
							</div>
							<div class="objectAddress"><p>{{objData.dis_name}}, {{objData.gk_street}}</p></div> <!--тут же должен быть номер дома, но его нигде не нашли-->
							<div class="objectPass">
								<div  class="objectPass-row blue-dot"><p>{{$GVO.str_replace(',', ', ',objData.b_decoration_list)}}</p></div>
								<div  class="objectPass-row blue-dot">
									<p v-if="objData.b_mortgage_flag == 1">Ипотека</p>
									<p v-if="objData.b_militarymortgage_flag == 1">Военная ипотека</p>
									<p v-if="objData.b_subsidy_flag == 1">Субсидии</p>
									<p v-if="objData.b_maternitycapital_flag == 1">Материнский капитал</p>
									<p v-if="objData.b_installment_flag == 1">Рассрочка</p>	
								</div>					
								<!--div class="objectPass-row blue-dot"><p>Тип договора (нет данных - Куратор)</p></div-->					
							</div>
						</div>
						<div class="col-sm-12 col-md-4 objectDev">
							<p>Срок сдачи: <span class="ml-2">{{$GVO.convertDateFromMysql(objData.b_endingperiod_min)}}</span></p>
							<p>Застройщик: <span class="ml-2">&laquo;{{objData.dev_name}}&raquo;</span></p>
						</div>
						<div class="col-sm-12 col-md-4 pr-0"> 							
							<!--div v-for="(kkv,key) in objData.PLAN_LIST" :key="objData.gk_name+key" class="objectPrice"><p>{{$GVO.GetCat('CAT_ROOMS',key).name}}</p><span></span><p> от {{$GVO.formatAmount(parseFloat(kkv[0].min_app_flatcostwithdiscounts))}}</p></!--div-->
							<div v-for="kkv in objData.ComplexMinFlatsBig" :key="kkv.id" class="objectPrice"><p>{{kkv.app_rooms}}</p><span></span><p> от {{$GVO.formatAmount(parseFloat(kkv.min_amount))}}</p></div>
						</div>						
					</div>					
				</div>
			</div>
		</card>
	</div>
</template>

<script>

	export default {
		name: 'ReSearchObjSmall',
		components: {            			
		},
		props: {
			objData: Object,
			findId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
				type: String,
				default: '',
			},
			
		},
		data () {
			return {
				ver: 1,
			}
		},
		computed: {

		},
		methods: {
			OpenComplex(gk_name_tr){
				//const masExcludeParams = ['dSearchType','p','c2p','dSortType','dSortOrder','dnotworkgk'];
				const masExcludeParams = ['p','c2p','AddComplexMinFlatsBig'];
				this.objGetParams = this.$GVO.GetAllGet();
				let strConstGetParams = '';
				let masParams = [];
				if(typeof this.objGetParams.task_id != 'undefined' && typeof this.objGetParams.taskend_id != 'undefined' && typeof this.objGetParams.client_id != 'undefined'){
					strConstGetParams = `?task_id=${this.objGetParams.task_id}&taskend_id=${this.objGetParams.taskend_id}&client_id=${this.objGetParams.client_id}`;
				}
				
				for (const key in this.objGetParams) {
					if (Object.hasOwnProperty.call(this.objGetParams, key)) {
						if(masExcludeParams.indexOf(key) == -1){
							if(key == 'dSearchType'){ 
								masParams.push(key+'=flat_list');
							}else if(key=='dminamount' || key=='dmaxamount'){
								masParams.push(key+'='+this.$GVO.str_replace(' ','',this.objGetParams[key]));
							}else{
								masParams.push(key+'='+this.objGetParams[key]);
							}
						}
					}
				}
				if(masParams.length > 0){
					strConstGetParams = '?'+masParams.join('&');
				}
				//this.$router.push({path: '/data/module/sso/object/complex/'+gk_name_tr+strConstGetParams});
				//console.log('/data/module/sso/object/complex/'+gk_name_tr+strConstGetParams);
				location.href = '/data/module/sso/object/complex/'+gk_name_tr+strConstGetParams;
			},

		},
	}
</script>
<style scoped>
.objectCard {border: 1px solid #9e77f3; box-shadow: 0px 3px 10px 0px rgba(123, 123, 123, 0.25)!important; margin-bottom: 20px;}
.objectPhoto img:hover {cursor: pointer; box-shadow: 0px 0px 10px rgba(1, 176, 224, 0.5); border: 1px solid #01b0e0;}
/*.objectCard:hover {cursor: pointer; box-shadow: 0px 0px 10px rgba(1, 176, 224, 0.5);}*/
.objectCard p {margin-bottom: 8px;}
.objectContent {display: flex;}
.leftPart {display: flex; margin-right: 10px; padding-right: 10px;}
.rightPart {display: flex; flex-direction: column; padding-left: 15px; width: 100%;}
.objectPhoto {width: 320px;}
.objectPhoto img {width: 100%; border: 1px solid transparent;}
.objectInfo{justify-content: space-between; align-items: baseline; width: 100%;}
.metro {display: flex; align-items: center; flex-wrap: wrap;}

.metroIc {margin-right: 7px;}
.metroIc {margin-bottom: 8px;}
.objectPass {display: flex; justify-content: flex-start; flex-wrap: wrap;}
.objectPass  p:not(:first-child) {margin-left: 10px; padding-left: 5px;position: relative;}
.objectPass p:not(:first-child)::before {
	content: '';
	position: absolute;
	height: 4px;
	width: 4px;
	border-radius: 50%;
	background: #ccc;
	left: -3px;
	top: 9px;
} 
.objectPass .blue-dot {margin-right: 7px; padding-right: 12px; position: relative;}
.objectPass .blue-dot:not(:last-child)::after {
	content: '';
	position: absolute;
	margin-left: 7px;
	height: 4px;
	width: 4px;
	border-radius: 50%;
	background: #01b0e0;
	top: 9px;
    right: 2px;
}
.objectPass-row {display: flex; flex-wrap: wrap;}
.objectPrice {text-align: end; padding-right: 0px;}
.objectPrice {display: flex; justify-content: space-between;}
.objectPrice span {flex: 1 1 0;
    max-width: 100%;
    height: 2px;
    margin: 9px 5px;
    border-bottom: 2px dotted #ccc;
}
.objectDev p:first-child {margin-right: 7px;}
.flats {padding-left: 5px;}
.gkTaskLink  {color: #9e77f3; font-weight: 300;}
.gkTaskLink:hover {color: #01b0e0; cursor: pointer;}

@media (max-width: 1200px) {
	.objectContent {flex-direction: column;}
	.leftPart {margin: 0 auto 20px auto;}
	.rightPart {padding-left: 0;}
}
@media (max-width: 768px) {	
	.objectHeader h4 {margin-bottom: 10px;}
	.objectPhoto {width: 100%;}
	.leftPart {padding-right: 0px;}
	.objectInfo {display: flex; flex-direction: column;}
	.objectBadges {text-align: start; display: flex; flex-direction: row; flex-wrap: wrap;}
	.flats {padding-right: 0px; padding-left: 15px;}
	.objectDev {display: flex; justify-content: space-between; padding-right: 0px;}
	.objectDev p:last-child {text-align: end;}
	.objectDev span {margin-left: 0px!important;}
}

</style>
